const QUERY_SUBSCRIPTION_CHANGE_RULES = `
  query SubscriptionTypeChangeRules {
    me {
      id
      subscription {
        current_expired_after_days
        current_duration {
          totes_left
        }
        subscription_type {
          id
          month_original_price
          display_name_v2
        }
      }
    }
    subscription_type_change_rules {
      id
      from_subscription_type {
        ...currentSubscription
      }
      patch_price_rate
      patch_tote_rate
      patch_customer_price
      patch_customer_tote
      to_subscription_type {
        ...currentSubscription
      }
      preview {
        cash_price
        final_price
      }
    }
  }

  fragment currentSubscription on SubscriptionType {
    id
    info_banner_config {
      banner_url
      tips
    }
    display_name_v2
    month_original_price
  }
`

const CHANGE_PLAN_BANNER = `query BannerGroup($display_position: String!) {
  banner_group(display_position: $display_position) {
    id
    display_position
    banners {
      extra
      height
      id
      image_url
      link
      title
      width
    }
  }
}`

const MUTATION_SUBSCRIPTION_CHANGE = `
mutation CustomerSubscriptionTypeChange(
  $input: CustomerSubscriptionTypeChangeInput!
) {
  CustomerSubscriptionTypeChange(input: $input) {
    payment {
      authorization_details
      id
      gateway
    }
    errors {
      error_code
      message
    }
    success
    order {
      successful
      id
    }
  }
}
`

export {
  QUERY_SUBSCRIPTION_CHANGE_RULES,
  CHANGE_PLAN_BANNER,
  MUTATION_SUBSCRIPTION_CHANGE
}
